import { render, staticRenderFns } from "./TempFooter.vue?vue&type=template&id=7b97aa1d&scoped=true&"
import script from "./TempFooter.vue?vue&type=script&lang=js&"
export * from "./TempFooter.vue?vue&type=script&lang=js&"
import style0 from "./TempFooter.vue?vue&type=style&index=0&id=7b97aa1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b97aa1d",
  null
  
)

export default component.exports